<template>
  <v-card>
    <v-card-text>
      <v-layout>
        <v-flex sm8>
          <h2 class="primary--text">
            ChatGPT Plus (Beta)
            <a href="https://blog.zwiz.app/chatgpt-plus/" target="blank">
              <i
                class="fas fa-question-circle"
                style="font-size: 18px; color: rgb(237, 30, 121);"
              ></i>
            </a>
          </h2>
          <span>กรุณากรอกข้อมูลร้าน เพื่อให้ Chat GPT ได้เรียนรู้เพิ่มเติม<br />รูปแบบการกรอกเป็นวลี เช่น ชื่อ : น้องซี และขึ้นบรรทัดใหม่ทุกครั้งที่เริ่มหัวข้อใหม่</span>
        </v-flex>
        <v-flex sm4>
          <div class="text-xs-right">
            <v-btn color="primary" outline @click="setSample()">
              <i class="fas fa-plus mr-2"></i>
              ตัวอย่างสำเร็จรูป
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <div class="mt-3">
        <v-container grid-list-md fluid pb-0 v-if="answersValue.length">
          <v-layout row wrap v-for="(answer, i) in answersValue" v-bind:key="i">
            <v-flex xs4>
              <div class="form-control">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('Topic Name')"
                  name="topic"
                  v-model="answer[0]"
                  @keypress="preventColon"
                  @input="event => onInputChanged(i, 0)"
                  :data-vv-as="$t('Topic Name')"
                  aria-describedby="Topic Name"
                />
              </div>
            </v-flex>
            <v-flex xs8 d-flex align-items-center>
              <div class="form-control mr-2" style="width: 100%;">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('data')"
                  name="data"
                  v-model="answer[1]"
                  @keypress="preventColon"
                  @input="event => onInputChanged(i, 1)"
                  :data-vv-as="$t('data')"
                  aria-describedby="data"
                />
              </div>
              <div class="d-flex" style="align-items: center;">
                {{ countAnwserLength(answer) }}/997
              </div>
              <v-btn flat icon @click="remove(i)">
                <v-icon>delete</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>

        <div class="text-xs-center mt-4" v-else>
          <span class="subheading">กรุณาเพิ่มวลีเพื่อให้ Chat GPT ได้เรียนรู้</span>
        </div>

        <div class="text-xs-center">
          <v-btn color="primary" @click="add()">{{ $t('Add') }}</v-btn>
        </div>
      </div>
      <div class="text-xs-center py-4">
        <v-btn color="primary" outline @click="cancel()">ยกเลิก</v-btn>
        <v-btn color="primary" @click="save()">บันทึก</v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  props: {
    answers: {
      type: Array
    },
    intent: {
      type: Object
    },
    dialogChatGPT: {
      type: Boolean
    }
  },
  data: function() {
    return {
      answersValue: this.answers ? _.map(this.answers, (answer) => _.split(answer, ' : ')) : [],
    }
  },
  methods: {
    setSample: async function() {
      const result = await this.$swal.fire({
        title: this.$t('chat_gpt_set_sample_comfirm_title'),
        text: this.$t('chat_gpt_set_sample_comfirm_text'),
        type: 'question',
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        showCancelButton: true,
        reverseButtons: true,
      })
      
      if (result.value) {
        this.answersValue = [
          ['ชื่อร้าน', ''],
          ['เบอร์ติดต่อร้าน', ''],
          ['ที่อยู่', ''],
          ['เว็บไซต์ร้าน', ''],
          ['วันทำการ', ''],
          ['เวลาทำการ', ''],
          ['ช่องทางสั่งซื้อ', ''],
          ['วิธีการสั่งซื้อ', ''],
          ['ประเภทสินค้าในร้าน', ''],
          ['สินค้าขายดี', ''],
          ['โปรโมชั่น', ''],
          ['ค่าส่งสินค้า', '']
        ]
      }
    },
    countAnwserLength: function(answer) {
      return _.chain(answer).join(' : ').size().value() - 3 // Remove " : "
    },
    preventColon(ev) {
      if (ev.key === ':') {
        ev.preventDefault()
      }
    },
    onInputChanged: function (i, j) {
      const combinedLength = this.answersValue[i][0].length + this.answersValue[i][1].length

      if (combinedLength >= 997) {
        if (j === 0) {
          const remainingLength = 994 - this.answersValue[i][1].length

          this.answersValue[i][0] = this.answersValue[i][0].slice(0, remainingLength)
        } else if (j === 1) {
          const remainingLength = 994 - this.answersValue[i][0].length

          this.answersValue[i][1] = this.answersValue[i][1].slice(0, remainingLength)
        } 
      }
    },
    add: function() {
      this.answersValue.push(['', ''])
    },
    remove: function(index) {
      this.answersValue.splice(index, 1)
    },
    cancel: function() {
      this.$emit('update:dialogChatGPT', false)
      this.answersValue = _.map(this.answers, (answer) => _.split(answer, ' : '))
    },
    save: async function() {
      try {
        this.$emit('update:dialogChatGPT', false)
        this.$store.dispatch('loading')

        let requestIntents
        let intent = this.intent
        const { userid: userId } = this.$store.state

        const answers = _(this.answersValue).filter((answer) => _.every(answer)).map((answer) => answer.join(' : ')).value()
        const aVal = JSON.stringify(answers)

        if (intent.id) {
          intent = {
            ...intent,
            a_val: aVal,
            updated_by: userId,
            updated_at: new Date().toISOString()
          }

          requestIntents = this.put(`intents?id=${intent.id}`, intent)
        } else {
          intent = {
            ...intent,
            intentname: '{default_gpt}',
            q_type: 'text',
            a_type: 'json',
            a_val: aVal,
            pageid: this.selectedBot.pageid,
            created_by: userId,
            created_at: new Date().toISOString()
          }

          requestIntents = this.post(`intents`, intent)
        }

        const response = await requestIntents

        if (response.responsecode === 200) {
          if (response.id) intent.id = response.id

          this.answersValue = _.map(answers, (answer) => _.split(answer, ' : '))

          this.$emit('update:intent', intent)
        } else {
          throw Error('Response code is not 200')
        }
      } catch (err) {
        this.$swal({
          type: 'error',
          title: this.$t('Error'),
          text: this.$t(`something_went_wrong`)
        })
        this.cancel()
      } finally {
        this.$store.dispatch('loading')
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/components/elements/ModalChatGPT.vue